import * as React from 'react';
import { Button } from '../button';
import { useCarousel } from './carousel';
import { SyntheticEvent } from 'react';

interface CarouselPreviousProps extends React.PropsWithChildren {}

export const CarouselPrevious = (
    props: CarouselPreviousProps & React.ComponentProps<typeof Button>,
) => {
    const {
        children,
        color = 'secondary',
        size = 'square40',
        shape = 'default',
        inverted = false,
    } = props;

    const { scrollPrev, canScrollPrev, canScrollNext } = useCarousel();
    const enableScroll = canScrollPrev || canScrollNext;

    const onScrollPrev = (evt: SyntheticEvent) => {
        evt.preventDefault();
        evt.stopPropagation();
        scrollPrev();
    };

    return enableScroll ? (
        <div className="rocco-carousel-previous z-20 flex items-center justify-center">
            <Button
                color={color}
                size={size}
                shape={shape}
                disabled={!canScrollPrev}
                inverted={inverted}
                onClick={onScrollPrev}
            >
                {children}
                <span className="sr-only">Previous slide</span>
            </Button>
        </div>
    ) : null;
};
